import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { __privateAdd, __privateGet, __privateSet } from "./chunk-PXG64RU4.js"; // src/removable.ts

import { isServer, isValidTimeout } from "./utils.js";

var _gcTimeout;

var Removable = /*#__PURE__*/function () {
  function Removable() {
    _classCallCheck(this, Removable);

    __privateAdd(this, _gcTimeout);
  }

  return _createClass(Removable, [{
    key: "destroy",
    value: function destroy() {
      this.clearGcTimeout();
    }
  }, {
    key: "scheduleGc",
    value: function scheduleGc() {
      var _this = this;

      this.clearGcTimeout();

      if (isValidTimeout(this.gcTime)) {
        __privateSet(this, _gcTimeout, setTimeout(function () {
          _this.optionalRemove();
        }, this.gcTime));
      }
    }
  }, {
    key: "updateGcTime",
    value: function updateGcTime(newGcTime) {
      this.gcTime = Math.max(this.gcTime || 0, newGcTime !== null && newGcTime !== void 0 ? newGcTime : isServer ? Infinity : 5 * 60 * 1e3);
    }
  }, {
    key: "clearGcTimeout",
    value: function clearGcTimeout() {
      if (__privateGet(this, _gcTimeout)) {
        clearTimeout(__privateGet(this, _gcTimeout));

        __privateSet(this, _gcTimeout, void 0);
      }
    }
  }]);
}();

_gcTimeout = new WeakMap();
export { Removable };